module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-hollandsnieuwe-01@2x.6b08fc2b.jpg";